module.exports = __webpack_public_path__ + "img/HongKongTrust4.1bb1abbe.png";